"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendInviteFriendsEvent = void 0;
var _1 = require(".");
var INVITE_FRIENDS_CONTEXT = "invite_friends";
var DEEPLINK_ACTION = "deeplink";
var KNOWN_PAGES = ["invite_notifications"];
var INVITE_MEDIUMS = ["twitter", "email"];
var generateInviteFriendsMetadata = function (_a) {
    var page = _a.page, medium = _a.medium;
    return {
        source: "web",
        medium: medium,
        campaign: "invitefriends",
        content: "invite-friends",
        page: page,
    };
};
var isExpectedPage = function (page) {
    return page && KNOWN_PAGES.includes(page);
};
var isExpectedMedium = function (page) {
    return page && INVITE_MEDIUMS.includes(page);
};
/**
 * Sends an event that the user has interacted with one of the Invite Friends to Wattpad
 * options.
 * Event name: "web:app:invite_friends::deeplink"
 */
var sendInviteFriendsEvent = function (_a) {
    var page = _a.page, medium = _a.medium;
    if (!isExpectedPage(page)) {
        console.warn("sendInviteFriendsEvent warning: ".concat(page, " is not included in the known pages for this event"));
    }
    if (!isExpectedMedium(medium)) {
        console.warn("sendInviteFriendsEvent warning: ".concat(page, " is not included in the known pages for this event"));
    }
    (0, _1.sendEvent)("app", INVITE_FRIENDS_CONTEXT, null, DEEPLINK_ACTION, generateInviteFriendsMetadata({ page: page, medium: medium }));
};
exports.sendInviteFriendsEvent = sendInviteFriendsEvent;
